export default __webpack_public_path__ + "static/media/Step1.a0412a4a.png";